import Splide from '@splidejs/splide';
//import $ from 'jquery';
// import lightbox from 'lightbox2';

// Import our default css theme for splide
import '@splidejs/splide/css';

// This should only be output on the frontend of the site - NOT the editor
const instances = [];

const init = () => {
		// $( ".wp-block-create-block-slideshow img" ).hide();
		$( ".wp-block-create-block-slideshow img" ).each(function () {
			$(this).wrap( '<a data-lightbox="slideshow" href="' + $(this).attr('src') +'" ></a>' );
		});

	let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
	let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

	// Splide
	const splides = document.querySelectorAll('.splide');
	if(!!splides && splides.length > 0){
		splides.forEach(splide => {
			let slideHeight = 600;

			if ($('body').hasClass('single-room')) {
				slideHeight = vw / (16 / 9);
			}

			if (vw > 992) {
				slideHeight = vh - 82;
			}

			// Grab the slide interval and convert it to an integer and milliseconds or fallback to 3000ms
			const interval = parseInt(splide.dataset.interval) * 1000 || 3000

			const instance = new Splide(splide, {
				type: 'loop',
				autoplay: true,
				focus    : 'center',
				perPage: 1,
				pauseOnHover: false,
				interval: interval,
				height: slideHeight,
				arrows: false,
				pagination: splide.dataset.showbullets === '1',
				drag: splide.querySelectorAll('li').length > 1,
				speed: 1900,
			}).mount();
			instances.push(instance);
		})
	}

	// lightbox;
};
document.addEventListener( 'DOMContentLoaded', () => {
	init();
});


// window.onresize = () => {
// 	clearTimeout(window.resizedFinished);
// 	window.resizedFinished = setTimeout(function(){
// 		instances.forEach(splide => {
// 			splide.destroy();
// 			init();
// 		})
// 	}, 260);
// };
